import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export enum SSOFieldsEnum {
  header = 'header',
  samlUrl = 'samlUrl',
  samlAccess = 'samlAccess',
  samlUser = 'samlUser',
}

export const screenFields: Record<SSOFieldsEnum, GenericFormItem[]> = {
  [SSOFieldsEnum.header]: [
    {
      gridXs: 12,
      gridMd: 4,
      label: 'SSO.FEDERATION_TYPE',
      stateKey: 'sso.federation_type',
      isSelect: true,
      options: [{ value: 'saml', label: 'SAML' }],
    },
    {
      gridXs: 12,
      gridMd: 8,
      label: 'SSO.CLIENT_REALM_ID',
      stateKey: 'sso.client_realm_id',
    },
  ],

  [SSOFieldsEnum.samlUrl]: [
    {
      gridXs: 12,
      gridMd: 4,
      label: 'SSO.IDP_ENTITY_IDP',
      stateKey: 'sso.saml_idp_entity_id',
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'SSO.SAML_IDP_SINGLE_SIGN_ON_URL',
      stateKey: 'sso.saml_idp_single_sign_on_url',
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'SSO.SAML_IDP_SINGLE_LOGOUT_URL',
      stateKey: 'sso.saml_idp_single_logout_url',
    },
    {
      gridXs: 12,
      label: 'SSO.SAML_X509_CERTIFIED',
      stateKey: 'sso.saml_idp_public_x509_cert',
    },
  ],

  [SSOFieldsEnum.samlAccess]: [
    {
      gridXs: 12,
      gridMd: 6,
      label: 'SSO.RESTRICT_ACCESS_BY_GROUPS',
      stateKey: 'sso.restrict_access_by_groups',
      isSelect: true,
      options: [
        { value: 0, label: 'NO_KEY' },
        { value: 1, label: 'YES_KEY' },
      ],
    },
    {
      gridXs: 12,
      gridMd: 6,
      label: 'SSO.ALLOW_USERS_FROM_GROUP',
      stateKey: 'sso.allow_users_from_group',
    },
  ],

  [SSOFieldsEnum.samlUser]: [
    {
      gridXs: 12,
      gridMd: 6,
      label: 'SSO.SAML_IDP_CLAIM_NAME_ID',
      stateKey: 'sso.saml_idp_claim_name_id',
    },
    {
      gridXs: 12,
      gridMd: 6,
      label: 'SSO.SAML_IDP_CLAIM_NAME_GIVEN_NAME',
      stateKey: 'sso.saml_idp_claim_given_name',
    },
    {
      gridXs: 12,
      gridMd: 6,
      label: 'SSO.SAML_IDP_CLAIM_SURNAME',
      stateKey: 'sso.saml_idp_claim_surname',
    },
    {
      gridXs: 12,
      gridMd: 6,
      label: 'SSO.SAML_IDP_CLAIM_EMAIL_ADDRESS',
      stateKey: 'sso.saml_idp_claim_email_address',
    },
    {
      gridXs: 12,
      gridMd: 6,
      label: 'SSO.SAML_IDP_CLAIM_GROUPS',
      stateKey: 'sso.saml_idp_claim_groups',
    },
  ],
};
